class Location {
  constructor() {
    this.city = null;
    this.countryCode = null;
    this.regionCode = null;
  }
}

export default class TransactionsEntity {
  constructor() {
    this.id = null;
    this.date = null;
    this.dateRaw = null;
    this.description = null;
    // The `shown on VM statement` merchant name from our narration
    this.merchantName = null;
    // Warning - it's an actual ODM rules `string` representation
    this.type = null;
    this.tag = null;
    this.tagId = null;
    this.amount = null;
    this.account = null;
    this.accountId = null;
    this.balance = null;
    this.accName = null;
    this.posted = null;
    this.accIndex = null;
    this.archived = null;
    this.credit = null;
    this.debit = null;
    this.isRefund = null;
    this.merchantCategoryCode = null;
    this.reference = null;

    this.isCardType = false;
    this.isATMType = false;
    this.isCardHolderPresent = false;

    this.location = new Location();
    this.geolocation = null;
    this.logo = null;
    // Enriched transaction address
    this.fullAddress = null;

    this.isEnrichAttempted = false;
    this.isDescriptionEnriched = false;
    this.rawAmount = null;
    this.sortCode = null;
  }
  setAccount(accName) {
    this.accName = accName;
  }
  setAccountIndex(index) {
    this.accIndex = index;
  }
  enrich(data) {
    this.isEnrichAttempted = true;

    if (!data) {
      return;
    }

    this.description = data.name;
    this.isDescriptionEnriched = true;

    this.logo = data.logos?.find(
      ({ type, height }) => type !== 'INDUSTRY' && height >= 200
    );

    this.geolocation = data.geolocation;

    if (data.address) {
      const { line1, line2, city, postalCode, countryName } = data.address;

      this.fullAddress = [
        line1,
        line2,
        `${city ?? ''} ${postalCode ?? ''}`,
        countryName,
      ]
        .filter((item) => item?.trim())
        .join(', ');
    }
  }
}
